var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"feedback-fixed-btn",attrs:{"aria-label":_vm.$t('Обращение')}},[_c('router-link',{attrs:{"to":_vm.$i18nRoute({ name: 'feedback-add' }),"aria-label":_vm.$t('Создать обращение'),"title":_vm.$t('Создать обращение')}},[_c('span',{staticClass:"feedback-icon",attrs:{"aria-hidden":"true"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }